export const API_B2C_DEVELOPMENT_BASE_URL = 'http://localhost:3100';
export const API_B2C_STAGING_BASE_URL = 'https://www.staging.leafio.com.au';
export const API_B2C_PRODUCTION_BASE_URL = 'https://www.leafio.com.au';
export const API_B2C_ORDERS_PATH = '/api/v1/supplier/orders';
export const API_B2C_ORDERS_DOCUMENT_DOWNLOAD_PATH = '/api/v1/document/download/2';
export const API_B2C_ORDERS_STATUS_PATH = '/api/v1/orders/status';
export const API_B2C_EXPORT_ORDERS_PATH = '/api/v1/supplier/export-orders';
